import React , {useRef, useState,useEffect} from 'react'
import './index.scss'
import Spinner from '../../../../components/spinner'
import { logIn, logInGoogle, LogInMobile } from '../../Helpers'
import { signInWithGoogle } from '../../Helpers/googleLogin'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { debounce } from '../../Helpers/constant'
import pubsub from "@viewlift/pubsub"
import google from './google.png'
import { initApple, signInApple } from '../../Helpers/appleSignIn.js'
import { fetchUserData,  sanitizeInputValue } from '../../../../helpers.js'
import { countries } from '../../../../components/UpdateAccount/helper.js'
import { validateAuth } from '../../Helpers/helper.js'
import { createAccountViaEmailPhone, encryptWithPublicKey } from '../../Helpers/login.js'
import { fetchCheckoutStore, updateCheckoutStore } from '../../../utils/CheckoutStore.js'
import { errorAlert, greenTick } from '../../../../../images/icon.js'
import { fetchUserObject } from '../../../../MFEs/Monetization-Sdk/src/fetchStore.js'
import { useNavigate } from 'react-router-dom'
import trackEvent from '../../../../helpers/trackAnalytics'
import { ANALYTICS, FB_EVENTS } from '../../../../helpers/analyticsMap.js'
import { flowSteps, handleStatusGaCalls, pushStepToFlow } from '../../../helper.js'
import { fetchCurrentPlan } from '../../../PlansWrapper/helper.js'
import { ANALYTICSEVENTS } from '../../Helpers/analyticsMap.js'
import Cookies from 'js-cookie';
import { parseJSON } from '../../../../MFEs/Monetization-Sdk/src/helper.js'
import useRecaptchaV3 from '../../../../recaptcha/useRecaptchaV3'
import { handleV3Recaptcha } from '../../../../recaptcha/helper'
import "../../../../recaptcha/style.scss"
import { publishAppLoading, publishErrorUpdate, publishUserCreated } from "../../../Events/utils.events.js";
import { dynamicConfig } from "../../../../components/DynamicRoutes/index.js";
import { getFontsStyles } from "../../../../modules/TrayModules/Helper/helper";
import CheckoutFormInputs from './CheckoutFormInputs.js'
import { getStorageItem } from '../../../../helpers/storageManager.js'
import { subscribePlansLoaded } from '../../../Events/plans.events'

const loadAppleScript = (locale = 'en_US') => 
  new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/${locale}/appleid.auth.js"]`)) return resolve()
    const script = document.createElement('script')
    script.src = `https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/${locale}/appleid.auth.js`
    script.onload = () => resolve()
    script.onerror = (err) => reject(err)
    document.body.appendChild(script)
})

function Form({state,metadataMap,moduleData,isCheckoutScreen, showTvProviderBtn,continueWithoutSubscription, continueWithoutSubscriptionLabel,checkoutModuleData,isFreeLogin}) {
  const getEnableValue = (provider) => {
    const socialLoginOptions = moduleData?.layout?.settings?.options?.socialLoginSignup
    const obj= socialLoginOptions?.find(item => item.title === provider);
    let enableValue = false
    if (obj) {
      enableValue = obj.enable;
    }
    return enableValue
  }
  let termsOfServiceText = checkoutModuleData?.moduleData?.metadataMap?.termsOfServiceText
  const emailConsentOptions = window?.app_data?.appcmsMain?.emailConsent
  const [formType, updateformType] = useState({});
  const[verifiedValue ,setVerifiedValue ] = useState('')
  const [areacode, setAreaCode] = useState("")
  const [progressState,setProgressState] = useState(1)
  const [formInputData, setFormInputData] = useState({
    name:"",
    phone:"",
    dob:"",
    zipCode:""
  })
  const [isFormDataValidated,setIsFormDataValidated] = useState({
    name:false,
    phone:false,
    dob:false,
    zipCode:false,
    username: false,
  })
  const [showBtn, setShowBtn] = useState(false);
  const input = useRef('')
  const [isEmpty ,setIsEmpty] = useState(true)
  const [errMsg , setErrMsg] = useState({msg: false, delay: 5000,type:''})
  const [successMsg, setSuccessMsg] = useState(false)
  const [loading , setLoading] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const [userExist, setUserExist] = useState(false)
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false)
  const [isEmailConsentEnable, setIsEmailConsentEnable] = useState(emailConsentOptions?.isChecked || false)
  const [isValidated, setIsValidated] = useState(false)
  const [recaptchaVerified, setRecaptchaVerified] = useState(null)
  let reCaptchaKeys = window?.app_data?.appcmsMain?.security?.reCaptchaKeys
  const siteKey = reCaptchaKeys?.siteKey
  let thresholdValue = parseInt(reCaptchaKeys?.thresholdValue || 0)
  const action = "login";
  const { executeRecaptcha } = useRecaptchaV3(siteKey, action);
  const [navigatePermalink, setNavigatePermalink] = useState({
    isActive: false,
    localisation: '',
    handleEventType: ''
  })
  const navigate = useNavigate()
  const escapeHtml = (text) => {
    const htmlEntities = {
        '"': "&quot;",
        "&": "&amp;",
        "'": "&#039;",
        "<": "&lt;",
        ">": "&gt;"
    };
    return text.replace(/["&'<>]/g, (char) => htmlEntities[char] || char);
  };
  const sanitizedTosText = metadataMap?.tosText ? escapeHtml(metadataMap.tosText) : '';
  const sanitizedPrivacyPolicyText = metadataMap?.privacyPolicyText ? escapeHtml(metadataMap.privacyPolicyText) : '';
  const sanitizedDelimiterText = checkoutModuleData?.moduleData?.layout?.settings?.delimiterText ? escapeHtml(checkoutModuleData?.moduleData?.layout?.settings?.delimiterText) : '';
  const sentizedWildCardDelimiterText = metadataMap?.delimiterText ? escapeHtml(metadataMap?.delimiterText) : '';
  const languageCode = window?.app_data?.appcmsMain?.languages?.default?.code || 'en';
  const locale = languageCode === 'es' ? 'es_MX' : 'en_US';
  const checkoutLayoutSettings = checkoutModuleData?.moduleData?.layout?.settings

  const handleAreaCode = () => {
    countries.forEach((country) => {
        if(country.code == window.app_data.countryCode){
          setAreaCode(country.dial_code)
        }
    })
  }

  const appendConsentEmailText = () => {
    const consentEmailTextElement = document.getElementById('email-consent-checkbox-label');
    let emailConsentText = emailConsentOptions?.message || metadataMap?.emailConsentText;
    if (consentEmailTextElement && emailConsentText) {
      emailConsentText = emailConsentText.replace('$terms_of_service$', `<a href="${encodeURI(metadataMap?.tosPermalink)}" class="consentLinks" target="_blank">${sanitizedTosText}</a>`);
      emailConsentText = emailConsentText.replace('$privacy_policy$', `<a href="${encodeURI(metadataMap?.privacyPolicyPermalink)}" class="consentLinks" target="_blank">${sanitizedPrivacyPolicyText}</a>`);
      consentEmailTextElement.innerHTML = '';
      consentEmailTextElement.insertAdjacentHTML('beforeend', emailConsentText);
    }
  }

  const appendText = () => {
    termsOfServiceText = metadataMap?.tosTextDesc?.replace('$terms_of_service$', `<a aria-label=${sanitizedTosText} href="${encodeURI(metadataMap?.tosPermalink)}" class="consentLinks" target="_blank">${sanitizedTosText}</a>`);
    termsOfServiceText = termsOfServiceText?.replace('$privacy_policy$', `<a aria-label=${sanitizedPrivacyPolicyText} href="${encodeURI(metadataMap?.privacyPolicyPermalink)}" class="consentLinks" target="_blank">${sanitizedPrivacyPolicyText}</a>`);
    termsOfServiceText = termsOfServiceText?.replace('$delimiter_text$', `<a aria-label=${sanitizedDelimiterText} href="${encodeURI(checkoutModuleData?.moduleData?.layout?.settings?.delimiterPagePath)}" class="consentLinks" target="_blank">${sanitizedDelimiterText}</a>`);
    if (metadataMap?.delimiterIdentifier && metadataMap?.delimiterPermalink){
      termsOfServiceText = termsOfServiceText?.replace(metadataMap?.delimiterIdentifier, `<a aria-label=${sentizedWildCardDelimiterText} href="${encodeURI(metadataMap?.delimiterPermalink)}" class="consentLinks" target="_blank">${sentizedWildCardDelimiterText}</a>`);
    }
    let authSubtitle = document.getElementById('authSubtitle');
    if(authSubtitle && termsOfServiceText){
      authSubtitle.innerText = '';
      authSubtitle.insertAdjacentHTML('beforeend', termsOfServiceText);
    }
  };

  const changeView = (data) => {
    if(data == 1) updateformType({})
    if(data == 2 || data == 3){ updateformType({
      type:"native",
      category:'email'
    })}
    setProgressState(data)
  }

  useEffect(() => {
    const response = fetchUserObject();
      if(response?.email || response?.phoneNumber){
        setVerifiedValue(response?.email || response?.phoneNumber)
        setIsUserLoggedIn(true)
        setIsDisabled(true)
        setUserExist(true)
        setLoading(false)
        pubsub.publish('card-disabled', false);
      } else {
        subscribePlansLoaded((data) => {
          const isValid = JSON.parse(sessionStorage.getItem('isCheckoutFormInputValid'));
          pubsub.publish('card-disabled', data && !isValid);
        })
      }
  },[])

  useEffect(() => {
    pubsub.subscribe("user", (data) => {
      const response = fetchUserObject();
      setVerifiedValue(data?.email || response?.email || response?.phoneNumber)
      setIsDisabled(true)
      setIsUserLoggedIn(true)
      setLoading(false)
      pubsub.publish('card-disabled', false);
  });
  },[])  

  useEffect(() => {
    appendText()
    appendConsentEmailText()
    // initializeFacebookLogin()
    if(getEnableValue("Apple")) {
      loadAppleScript(locale).then(() =>{
        initApple(isCheckoutScreen);
      })
    }
 },[moduleData]);
const handleLoader = (data) => {
  setLoading(data)
}

const handleRedirection = (data) => {
  pubsub.publish('apploading', false)
  const isSubscribed = data?.isSubscribed
  const provider = data?.provider
  const currentPath = location.pathname

  if(Cookies.get('RedirectToActivate') === "true") {
    let activationCode = Cookies.get('activationCode')
    let redirectUrl;
    if (!activationCode) redirectUrl = "/activate"
    else redirectUrl = "/activate?code="+activationCode
    navigate(redirectUrl)
  } else if(Cookies.get('RedirectToRedeem') === "true"){
    let activationCode = Cookies.get('giftCode')
    let redirectUrl
    if(activationCode){
      redirectUrl = "/redeem?code="+activationCode
    }else{
      redirectUrl = "/redeem"
    }
    navigate(redirectUrl)
  }else{
    if(provider == "APPLE" || provider == "GOOGLE") {
      const response = fetchUserObject()
        if(response?.email){
          setVerifiedValue(response?.email)
        }
    }
    if(provider == "EMAIL" || provider == "MOBILE") {
      pubsub.publish("verifyOtp", {screen:false,type:''})
      setErrMsg({...errMsg, msg: false,type:''})
    }
  
    if(!isSubscribed){
      currentPath == '/checkout' || currentPath !== "/authentication" ? false : navigate('/')
    } else {
      currentPath == '/checkout' ? navigate('/') : false
    }
    pubsub.publish('redirection',true)
    setIsUserLoggedIn(true)
    setIsDisabled(true)
    pubsub.publish('card-disabled', false);
  }
}

useEffect(() => {
   (async () => {
      let recaptchaVerified = await handleV3Recaptcha(executeRecaptcha,thresholdValue);
      if (recaptchaVerified) {
        setRecaptchaVerified(true)
      }else {
        setRecaptchaVerified(false)
      }
      setLoading(false)
    })()
}, [executeRecaptcha]);

 useEffect(() => {
  pubsub.subscribe("isLoading",handleLoader)
  pubsub.subscribe('progressState',changeView)
  pubsub.subscribe('isAuthenticated',handleRedirection)
  if(state){
    updateformType(
      {
        type:"native",
        category:state
      })
  }
  handleAreaCode()
 },[])

 React.useEffect(() => {
  if(errMsg.msg){
    setTimeout(() => {
      setErrMsg({...errMsg, msg: false,type:''})
      setNavigatePermalink({...navigatePermalink, isActive: false})
    }, errMsg.delay)
  }
},[errMsg.msg])

useEffect(() => {
  const splashSignupEmail = parseJSON(sessionStorage.getItem("splashSignupEmail"))
  if(splashSignupEmail?.length){
    setVerifiedValue(splashSignupEmail)
    setIsDisabled(true)
    updateCheckoutStore({ userDetails: {e: splashSignupEmail, emailConsent: isEmailConsentEnable}})
    pubsub.publish('card-disabled', false);
  }
 },[])

const handleVerified = (e) => {
  if (e.target.value === '') {
    setIsEmpty(true);
    setIsValidated(false);
    setIsFormDataValidated((prev) => ({ ...prev, username: false }));
  }
  setSuccessMsg(false);
  setErrMsg({...errMsg, msg: false,type:''})
  setIsEmpty(false);
const _value = sanitizeInputValue(e.target.value)
   setVerifiedValue(_value)
  if(formType.type !== "native" || formType.category !== checkType(_value)){
    updateformType( {
      type:"native",
      category:checkType(_value)
    })
  }
}

    const getErrorMessage = (err) => {
      let code = err?.code || err
       switch(code) {
      case 'PHONE_INVALID':
        setErrMsg({...errMsg, msg: metadataMap["PHONE_NOT_VALID"], delay: 5000,type:'email'})
        break;
      case "PHONE_ALREADY_REGISTERED":
        setErrMsg({...errMsg, msg: metadataMap["PHONE_ALREADY_REGISTERED"], delay: 5000,type:'email'})
        break;
      case 'EMAIL_NOT_VALID':
        setErrMsg({...errMsg, msg: metadataMap["EMAIL_NOT_VALID"], delay: 5000,type:'email'})
        break;
      case 'EMAIL_FORMAT_NOT_VALID':
          setErrMsg({...errMsg, msg: "Email Format Not Valid", delay: 5000,type:'email'})
            break; 
      case 'EMAIL_FORMAT_NOT_VALID_PHONE':
          setErrMsg({...errMsg, msg: metadataMap["EMAIL_FORMAT_NOT_VALID"], delay: 5000,type:'phone'})
          setIsValidated(false);
          setIsDisabled(false);
          setUserExist(false);
          getSuccessMessage('USER_NOT_VALIDATED');
          // reset error and remove sigin link, if user enter invalid email after colsing the verifyOtp window.
          setNavigatePermalink({...navigatePermalink, isActive: false});
            break; 
      case 'MAX_NUMBER_OF_OTP_EXCEEDED':
          setErrMsg({...errMsg, msg: metadataMap?.["MAX_NUMBER_OF_OTP_EXCEEDED"] || "OTP Limit Exceeded", delay: 5000,type:''})
            break; 
      case 'ACCOUNT_NOT_EXIST':
        setNavigatePermalink({...navigatePermalink, isActive:true, handleEventType: 'signUp', localisation: metadataMap?.["ACCOUNT_NOT_EXIST"]?.match(/\$(.*?)\$/)?.[1] || 'Create a new account'})
        setErrMsg({...errMsg, msg:metadataMap?.["ACCOUNT_NOT_EXIST"] || "Please enter a valid email address or", delay: 120000,type:'email'})
        break;
        case 'UNVERIFIED_PHONE':
        setErrMsg({...errMsg, msg: metadataMap?.["UNVERIFIED_PHONE"] || "Cannot sign with unverified phone", delay: 5000,type:'email'})
        break;
        case 'UNVERIFIED_EMAIL':
          setErrMsg({...errMsg, msg: metadataMap?.["UNVERIFIED_EMAIL"] || "The entered email or mobile is not verified. Please log in with the associated account and try again.", delay: 5000,type:'email'})
          break;
        case 'INPUT_NAME_MISSING':
          setErrMsg({...errMsg, msg: metadataMap["INPUT_NAME_MISSING"], delay: 5000,type:'name'})
          break;
        case 'INPUT_DOB_MISSING':
          setErrMsg({...errMsg, msg: metadataMap["INPUT_DOB_MISSING"], delay: 5000,type:'dob'})
          break;
        case 'INVALID_DOB_FORMAT':
          setErrMsg({...errMsg, msg: metadataMap["INVALID_DOB_FORMAT"], delay: 5000,type:'dob'})
          break;
        case 'INPUT_ZIPCODE_MISSING':
          setErrMsg({...errMsg, msg: metadataMap["INPUT_ZIPCODE_MISSING"], delay: 5000,type:'zipCode'})
          break;
        case 'INPUT_PHONE_OR_EMAIL_MISSING':
          setErrMsg({...errMsg, msg: metadataMap["INPUT_PHONE_OR_EMAIL_MISSING"], delay: 5000,type:'phone'})
          break;
        case 'ACCOUNT_ALREADY_EXIST':
        setNavigatePermalink({...navigatePermalink, isActive:true, handleEventType: 'signIn', localisation: 'Sign In'})
        setErrMsg({...errMsg, msg:metadataMap?.["EMAIL_ALREADY_EXIST"] ? `${metadataMap?.["EMAIL_ALREADY_EXIST"]} $Sign In$` : "Account Already Exist! $Sign In$", delay: 120000,type:'email'})
        setIsValidated(false);
        setIsDisabled(false);
        setUserExist(false);
        getSuccessMessage('USER_NOT_VALIDATED')
        break;  
      default:  
      if (err?.error) setErrMsg({...errMsg, msg: err?.error, delay: 5000,type:''})
      else setErrMsg({...errMsg, msg: metadataMap["INVALID_REQUEST_PARAMS"], delay: 5000,type:''})
    }
    }

    const getSuccessMessage = (success) => {
      let code = success?.code || success
       switch(code) {
      case 'USER_VALIDATED':
        setSuccessMsg(true)
        break;
      case 'USER_NOT_VALIDATED':
        setSuccessMsg(false)
        break;
      default:  
      console.log('success')
    }
    }

    const initiateOtp = () => {
      formType.category === "email" && logIn({email:verifiedValue}).then((res) => {
        pubsub.publish('verifyOtp',{type:{type:'email',value:verifiedValue,emailConsent:isEmailConsentEnable,key:res?.identityAuthOtpInitiate?.key},screen:true,value:verifiedValue})
        triggerUserBeaconEvents('CHECKOUT_USER_LOGIN_INIT', false)
        handleStatusGaCalls({eventName : 'checkout_user_login_init',subSection : null, type : 'login', reason : 'true', status : null, action : 'Login Initiated', paymentStatus : null,eventCategory : 'Checkout'})
      })

      formType.category === "mobile" && LogInMobile({
        phoneNumber:'+' + areacode + verifiedValue
      }).then((res) => {
        pubsub.publish('verifyOtp',{type:{type:'mobile',value: '+' + areacode + verifiedValue,key:res?.identityAuthOtpInitiate?.key},screen:true,value: '+' + areacode + verifiedValue})
        handleStatusGaCalls({eventName : 'checkout_user_login_init',subSection : null, type : 'login', reason : 'true', status : null, action : 'Login Initiated', paymentStatus : null,eventCategory : 'Checkout'})
        triggerUserBeaconEvents('CHECKOUT_USER_LOGIN_INIT', false)
      })
    }

    const setVerificationWindow = async(e) => {
      e.preventDefault()
      setErrMsg({...errMsg, msg: false,type:''})
      setIsFormDataValidated((prev) => ({ ...prev, username: true }));
      const regexPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"; // checking email formate in uppercase and lower case
      const regexFlag = "gmi"
      if(formType.category === "email"  && (new RegExp(regexPattern, regexFlag)).test(verifiedValue)){
        let analyticsData={ename:ANALYTICSEVENTS.GET_VERIFICATION_CODE,data:{email:verifiedValue}};
        pubsub.publish('user-analytics',analyticsData)
        pubsub.publish('apploading', true);
        const encryptEmail = await encryptWithPublicKey(verifiedValue)
        const validatePayload = {
          e: encryptEmail
        }
        const encryptPhone = await encryptWithPublicKey('+' + areacode + formInputData?.phone)
        validateAuth(validatePayload).then((res) => {
          pubsub.publish('apploading', false);
          let getCheckoutStore = getStorageItem('CheckoutStore') || {}
          const isAccountExist = res.data.iae
          if((getCheckoutStore?.userDetails?.e) !== verifiedValue){
            handleStatusGaCalls({eventName : 'get_verification_code',subSection : null, type : 'verification', reason : 'email', status : null, action : 'Request Code', paymentStatus : null,eventCategory : 'Verification'})
          }
          setIsValidated(isAccountExist)
          if(isAccountExist){
            // login_init call
            if((getCheckoutStore?.userDetails?.e) !== verifiedValue){
              handleStatusGaCalls({eventName : 'login_init',subSection : 'login', type : 'initiate', reason : null, status : null, action : 'Init', paymentStatus : null,eventCategory : 'Authentication'})
            }
            if(isAccountExist && isCheckoutScreen){
              setUserExist(false)
              setIsDisabled(false)
              getErrorMessage('ACCOUNT_ALREADY_EXIST')
              setIsFormDataValidated((prev) => ({ ...prev, username: false }));
              setSuccessMsg(false)
            }
            isAccountExist && !isCheckoutScreen && logIn({email:verifiedValue}).then((res) => {
              pubsub.publish('verifyOtp',{type:{type:'email',value:verifiedValue,emailConsent:isEmailConsentEnable,key:res?.identityAuthOtpInitiate?.key},screen:true,value:verifiedValue})
            }
          )
            .catch((err) => {
              // login failure call
            handleStatusGaCalls({eventName : 'login_failure',subSection : 'login', type : 'failure', reason : err.message, status : null, action : 'Failure', paymentStatus : null,eventCategory : 'Authentication'})
              getErrorMessage(err.message)
            })
          } else{
            if(isCheckoutScreen){
              if((getCheckoutStore?.userDetails?.e) !== verifiedValue){
                handleStatusGaCalls({eventName : 'checkout_user_verification',subSection : null, type : 'verification', reason : 'true', status : null, action : 'Verification Called', paymentStatus : null,eventCategory : 'Checkout'})
                getSuccessMessage('USER_VALIDATED')
                handleStatusGaCalls({eventName : 'signup_init',subSection : 'login', type : 'initiate', reason : null, status : null, action : 'Init', paymentStatus : null,eventCategory : 'Authentication'})
              }
              triggerUserBeaconEvents('CHECKOUT_USER_VERIFICATION', true)
              let phoneNumber = formInputData?.phone !== "" ? '+' + areacode + formInputData.phone : ""
              setIsDisabled(true)
              // signin_init call
              // handleStatusGaCalls({eventName : 'sign_success',subSection : 'login', type : 'success', reason : null, status : null, action : 'Success', paymentStatus : null,eventCategory : 'Authentication'})
              // handleStatusGaCalls({eventName : 'sign_failure',subSection : 'login', type : 'failure', reason : err.message, status : null, action : 'Failure', paymentStatus : null,eventCategory : 'Authentication'})
              updateCheckoutStore({ userDetails: {e: verifiedValue, emailConsent: isEmailConsentEnable,p: phoneNumber,name:formInputData?.name,dob:formInputData?.dob,userZipcode:formInputData?.zipCode }})
              showBtn && pubsub.publish('card-disabled', false);
              setIsValidated(true);
            } 
            else {
              getErrorMessage("ACCOUNT_NOT_EXIST")
              setIsFormDataValidated((prev) => ({ ...prev, username: false }));
              setIsEmpty(true)
          }
          }
        }).catch(err=>{
          pubsub.publish('apploading', false);
          getErrorMessage(err?.response?.data?.code)
          setIsFormDataValidated((prev) => ({ ...prev, username: false }));
        })
        
      }else if(formType.category === "email" && !(new RegExp(regexPattern, regexFlag)).test(verifiedValue)){
        getErrorMessage("EMAIL_FORMAT_NOT_VALID")
        setIsFormDataValidated((prev) => ({ ...prev, username: false }));
      }else if((formType.category === "mobile") && hideMobileNumber){
        getErrorMessage("EMAIL_FORMAT_NOT_VALID")
      }else if(formType.category === "mobile"){
        let analyticsData={ename:ANALYTICSEVENTS.GET_VERIFICATION_CODE,data:{phoneNo:'+' + areacode + verifiedValue}};
        pubsub.publish('user-analytics',analyticsData);
        pubsub.publish('apploading', true);
        const encryptPhone = await encryptWithPublicKey('+' + areacode + verifiedValue)
        const validatePayload = {
          p: encryptPhone
        }
        const encryptEmail = await encryptWithPublicKey(verifiedValue)
        validateAuth(validatePayload).then((res) => {
          pubsub.publish('apploading', false);
          const isAccountExist = res.data.iae
          setIsValidated(isAccountExist)
          if(isAccountExist){
            if(isCheckoutScreen && isAccountExist){
              setUserExist(false)
              setIsDisabled(false)
              getErrorMessage('ACCOUNT_ALREADY_EXIST')
              setSuccessMsg(false)
            }
          isAccountExist && !isCheckoutScreen && LogInMobile({
            phoneNumber:'+' + areacode + verifiedValue
          }).then((res) => {
            setLoading(false)
            handleStatusGaCalls({eventName : 'get_verification_code',subSection : null, type : 'verification', reason : 'mobile', status : null, action : 'Request Code', paymentStatus : null,eventCategory : 'Verification'})
            pubsub.publish('verifyOtp',{type:{type:'mobile',value: '+' + areacode + verifiedValue,key:res?.identityAuthOtpInitiate?.key},screen:true,value: '+' + areacode + verifiedValue})
          })
          .catch((err) => {
            setLoading(false)
            getErrorMessage(err.message)
          })
          }else{
            if(isCheckoutScreen){
              triggerUserBeaconEvents('CHECKOUT_USER_VERIFICATION', true)
              handleStatusGaCalls({eventName : 'checkout_user_verification',subSection : null, type : 'verification', reason : 'true', status : null, action : 'Verification Called', paymentStatus : null,eventCategory : 'Checkout'})
              // setIsDisabled(true)
              setLoading(false)
              getSuccessMessage('USER_VALIDATED')
              updateCheckoutStore({ userDetails: {p: '+' + areacode + verifiedValue, emailConsent: isEmailConsentEnable,e:encryptEmail,name:formInputData?.name,dob:formInputData?.dob,userZipcode:formInputData?.zipCode}})
              showBtn && pubsub.publish('card-disabled', false);
            } 
           else{
            getErrorMessage("ACCOUNT_NOT_EXIST")
            setIsEmpty(true)
            setLoading(false)
          }
          }
        })
      }
    }


    const requiredFields = {
      name:checkoutLayoutSettings?.isNameRequired || false,
      phone:checkoutLayoutSettings?.isSecondaryFieldRequired || false,
      dob:checkoutLayoutSettings?.isDOBRequired || false,
      zipCode:checkoutLayoutSettings?.isZipCodeRequired || false,
      username: true,
    };

    const handleValueChange = (e) => {
      const { name, value } = e.target;
       setFormInputData((prev) => ({ ...prev, [name]: value }));
    };

    const validateDOBFormat = (dob) => {
      return /^\d{2}-\d{2}-\d{4}$/.test(dob);
    };
    

  const handleGameOnBlur = (e, value) => {
     if (e?.preventDefault) e.preventDefault();
    const { phone, name, dob, zipCode } = formInputData;
    const trimmedValue = (val) => val?.toString().trim();
    const emailRegex = /^[A-Z0-9._+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    switch (value) {
      case "phone": {
        const contactValue = trimmedValue(phone);
        const isEmailValid = emailRegex.test(contactValue);
        if (checkoutLayoutSettings?.isSecondaryFieldRequired && !contactValue) {
          getErrorMessage("INPUT_PHONE_OR_EMAIL_MISSING");
          setIsFormDataValidated((prev) => ({ ...prev, phone: false }));
          return;
        }
        if (
          requiredFields?.isSecondaryFieldRequired &&
          formType.category === "mobile" &&
          !contactValue
        ) {
          getErrorMessage("INPUT_PHONE_OR_EMAIL_MISSING");
          setIsFormDataValidated((prev) => ({ ...prev, phone: false }));
          return;
        }
        if (!isEmailValid && formType.category === "mobile") {
          getErrorMessage("EMAIL_FORMAT_NOT_VALID_PHONE");
          setIsFormDataValidated((prev) => ({ ...prev, phone: false }));
          return;
        }
        setIsFormDataValidated((prev) => ({ ...prev, phone: true }));
        break;
      }
      case "name": {
        const nameTrimmed = trimmedValue(name);
        if (!nameTrimmed && requiredFields?.name) {
          getErrorMessage("INPUT_NAME_MISSING");
          setIsFormDataValidated((prev) => ({ ...prev, name: false }));
          return;
        }
        setIsFormDataValidated((prev) => ({ ...prev, name: true }));
        break;
      }
      case "zipCode": {
        const zipTrimmed = trimmedValue(zipCode);
        if (!zipTrimmed && requiredFields?.zipCode) {
          getErrorMessage("INPUT_ZIPCODE_MISSING");
          setIsFormDataValidated((prev) => ({ ...prev, zipCode: false }));
          return;
        }
        setIsFormDataValidated((prev) => ({ ...prev, zipCode: true }));
        break;
      }
      case "dob": {
        const dobTrimmed = formInputData?.dob?.toString().trim();

        if (!dobTrimmed && requiredFields?.dob) {
          getErrorMessage("INPUT_DOB_MISSING");
          setIsFormDataValidated(prev => ({ ...prev, dob: false }));
          return false;
        }

        if (dobTrimmed && !validateDOBFormat(dobTrimmed)) {
          getErrorMessage("INVALID_DOB_FORMAT");
          setIsFormDataValidated(prev => ({ ...prev, dob: false }));
          return false;
        }

        setIsFormDataValidated(prev => ({ ...prev, dob: true }));
        break
      }
        default:
          break;
      }
      setVerificationWindow(e);
    };
    

    const handleOnChange = value => {
      setAreaCode(value)
    };

    const initGoogleSignIn = () => {
      signInWithGoogle().then((res) => {
        logInGoogle(res._tokenResponse.oauthIdToken, isCheckoutScreen)
        pubsub.publish('FB-analytics',{eventType : FB_EVENTS.LOGIN ,payload : {platform: 'Web', registrationType: 'Google'},type : "FB"})
      }).catch((error) => {
        console.log(error.message)
      })
    }

    const disableCtaColor = moduleData?.layout?.settings?.disabledCTAColor || 'transparent'
    const activeCtaColor = moduleData?.layout?.settings?.activeCTAColor || 'transparent'
    const inputColor = moduleData?.layout?.settings?.inputBgColor || 'transparent'
    const activeCtaTextColor= window?.app_data?.appcmsMain?.brand?.cta?.primary?.textColor || "#ffffff";
    const hideMobileNumber = moduleData?.layout?.settings?.hideMobileNumber
    const checkoutInputBgColor = moduleData?.layout?.settings?.overrideInputBgColor || "#f6f2f2"
    const checkoutInputColor = moduleData?.layout?.settings?.overridetextColor || "#0d0d0d"
    const siteCtaColor = window?.app_data?.appcmsMain?.brand?.cta?.primary?.backgroundColor || "#fff";

    const checkType = (value) => {
      const primaryCategory = checkoutLayoutSettings?.primaryField || "both";
      if (primaryCategory === 'both') {
      if(value === '') return 'email'
      return (/[a-z]|[A-Z]/g).test(value) || value.includes('@') ? 'email' : 'mobile'
      } else {
        return primaryCategory;
      }
    }

  useEffect(() => {
  if (!requiredFields || !isFormDataValidated) {
    setShowBtn(false);
    pubsub.publish('card-disabled', true);
    return;
  }

  const requiredKeys = Object?.keys(requiredFields)?.filter(
    key => requiredFields[key] === true
  );

  const allValid = requiredKeys.every(
    key => isFormDataValidated[key] === true
  );

  setShowBtn(allValid);
  pubsub.publish('card-disabled', !allValid);
  sessionStorage.setItem('isCheckoutFormInputValid', JSON.stringify(allValid));
}, [isFormDataValidated, requiredFields]);

    const handleEnableTveFlow = () => {
      const res = fetchUserObject();
          if(res == undefined){
          setLoading(true)
          fetchCheckoutStore().then((checkoutStore) => {
            if (!checkoutStore?.userDetails) {
              setLoading(false)
            return 
            }
            let userDetails = checkoutStore?.userDetails
            const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
            let eventData = {
              "pageUrl": checkoutInitPageDetails?.pageUrl
            }
              createAccountViaEmailPhone(userDetails).then((res) => {
                const getSecureTveWrapper = document.getElementById('tveProviderSecureWall')
                const getSecureWrapperBtn = document.getElementById('initiateTveBtn')
                getSecureTveWrapper.style.display = "none"
                getSecureWrapperBtn.style.display = "none"
                let analyticsData={ename:ANALYTICSEVENTS.GUEST_USER_TVE_LOGIN,data:{email:verifiedValue}};
                pubsub.publish('user-analytics',analyticsData)

                userDetails?.e ? (eventData.email = userDetails?.e, eventData.registeredVia = "email") : eventData.phoneNumber = (userDetails?.p, eventData.registeredVia = "phone number")
                let analyticsEventData={ename: ANALYTICSEVENTS.CHECKOUT_USER_CREATE_SUCCESS, data: eventData};
                pubsub.publish('user-analytics',analyticsEventData)
                trackEvent('login', { method: "tve" },null)
                setUserExist(true)
                handleStatusGaCalls({eventName : 'checkout_user_create_success',subSection : null, type : 'login', reason : 'true', status : null, action : 'Create Account', paymentStatus : null,eventCategory : 'Checkout'})
                userDetails?.e ? pushStepToFlow("email added") : pushStepToFlow("phone number")
                let status = res?.status
                if (!status) {
                  setLoading(false)
                  return
                }
                setLoading(false)
              }).catch((err) => {
                userDetails?.e ? (eventData.email = userDetails?.e, eventData.registeredVia = "email") : eventData.phoneNumber = (userDetails?.p, eventData.registeredVia = "phone number")
                let analyticsEventData={ename: ANALYTICSEVENTS.CHECKOUT_USER_CREATE_FAILURE, data: eventData};
                handleStatusGaCalls({eventName : 'checkout_user_create_failure',subSection : null, type : 'login', reason : 'true', status : null, action : 'Create Account', paymentStatus : null,eventCategory : 'Checkout'})
                pubsub.publish('user-analytics',analyticsEventData)
              })
          }).catch((e) => {
          setLoading(false)
          })
        }else{
          const getSecureTveWrapper = document.getElementById('tveProviderSecureWall')
          const getSecureWrapperBtn = document.getElementById('initiateTveBtn')
          getSecureTveWrapper.style.display = "none"
          getSecureWrapperBtn.style.display = "none"
        }
    }

    const handleValidateOnEvent = (e) => {
      if(e.keyCode == 13 || e.keyCode == 9 ){
        triggerUserBeaconEvents('CHECKOUT_USER_DETAIL_ADDED', true)
        handleStatusGaCalls({eventName : 'checkout_user_detail_added',subSection : null, type : 'user-detail', reason : 'true', status : null, additionalLabel : null, action : 'Detail Added', paymentStatus : null,eventCategory : 'Checkout',section : 'checkout'})
        setVerificationWindow(e)
      }
    }

    const handleValidateOnBlur = (e) => {
        triggerUserBeaconEvents('CHECKOUT_USER_DETAIL_ADDED', true)
        handleStatusGaCalls({eventName : 'checkout_user_detail_added',subSection : null, type : 'user-detail', reason : 'true', status : null, additionalLabel : null, action : 'Detail Added', paymentStatus : null,eventCategory : 'Checkout',section : 'checkout'})
        setVerificationWindow(e)
    }

    const handleValidateOnTab = (e) => {
      if(userExist) return;
      if(e.keyCode == 13 || e.type == "click"){
        const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
        let consentEmailData = {
          "pageUrl": checkoutInitPageDetails?.pageUrl,
          "consentStatus": !isEmailConsentEnable ? "accepted" : "declined"
        }
        let analyticsData={ename:ANALYTICSEVENTS.EMAIL_USER_CONSENT, data: consentEmailData};
        handleStatusGaCalls({eventName : 'user_consent',subSection : null, type : 'user-detail', reason : consentEmailData?.consentStatus, status : null, additionalLabel : null, action : !isEmailConsentEnable ?  'Opt-Out' : 'Opt-In', paymentStatus : null,eventCategory : 'Engagement',section : 'checkout'})
        pubsub.publish('user-analytics',analyticsData)
        setIsEmailConsentEnable(!isEmailConsentEnable)
        formType.category === "email" && updateCheckoutStore({ userDetails: {e: verifiedValue, emailConsent: !isEmailConsentEnable}})
        formType.category === "mobile" && updateCheckoutStore({ userDetails: {p: '+' + areacode + verifiedValue, emailConsent: !isEmailConsentEnable}})
      }
    }

    const handleSignInEventRedirection = () => {
      let plan = fetchCurrentPlan()
      let pageData = window?.page_data?.page
      let pageId = pageData?.id
      let pageTitle = pageData?.title
      let eventdata = {
        "pageUrl": window?.location.href,
        "pgName" : pageTitle,
        "pgId" : pageId,
        "modType" : moduleData?.layout?.type,
        "modID": moduleData?.layout?.id,
        "monetizationType": plan?.type || "",
        "planName" : plan?.title  || "", 
        "planID" : plan?.planId  || "",
        "stepsCompleted": flowSteps,
      }
    navigate('/checkout')
    sessionStorage.setItem('checkoutInitPageData', JSON.stringify({"pageUrl": window?.location.href, "pgName" : pageTitle, "pgId" : pageId}))
    pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.NEW_ONBOARDING_CHECKOUT_INIT, data: eventdata});
    }

    const triggerUserBeaconEvents = (eventType , register) => {
      const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
      let eventData = {
        "pageUrl": checkoutInitPageDetails?.pageUrl,
        "email" : formType.category === "email" ? verifiedValue : null,
        "phoneNumber" : formType.category === "mobile" ? verifiedValue : null,
      }
      register ? eventData.registeredVia = (formType.category === "email" ? 
      "email" : "phone number") : (eventData.loginVia = formType.category === "email" ? "email" : "phone number")
      let analyticsData={ename: ANALYTICSEVENTS[eventType], data: eventData};
      pubsub.publish('user-analytics',analyticsData)
    }
    const onContinueWithoutSubscription = () => {
      if (!verifiedValue) return
      const res = fetchUserObject()
        if(res == undefined){
        setLoading(true)
        fetchCheckoutStore().then((checkoutStore) => {
          if (!checkoutStore?.userDetails) {
            setLoading(false)
          return 
          }
          let userDetails = checkoutStore?.userDetails
          const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
          let eventData = {
            "pageUrl": checkoutInitPageDetails?.pageUrl
          }
          createAccountViaEmailPhone(userDetails).then((res) => {
            // user creation
            userDetails?.e ? (eventData.email = userDetails?.e, eventData.registeredVia = "email") : eventData.phoneNumber = (userDetails?.p, eventData.registeredVia = "phone number")
            let analyticsEventData={ename: ANALYTICSEVENTS.CHECKOUT_USER_CREATE_SUCCESS, data: eventData};
            handleStatusGaCalls({eventName : 'checkout_user_create_success',subSection : null, type : 'login', reason : 'true', status : null, action : 'Login Success', paymentStatus : null,eventCategory : 'Checkout'})
            pubsub.publish('user-analytics',analyticsEventData)
            handleStatusGaCalls({eventName : 'signup_success',subSection : 'login', type : 'success', reason : null, status : null, action : 'Success', paymentStatus : null,eventCategory : 'Authentication'})
            userDetails?.e ? pushStepToFlow("email added") : pushStepToFlow("phone number")
            let analyticsData={ename:ANALYTICS.USER_CREATED,data:res};
            pubsub.publish('user-analytics',analyticsData)
            trackEvent('USER_CREATED', res,null)
            let status = res?.status
            if (!status) {
              publishAppLoading(false)
              return
            }
            fetchUserData().then(async () => {
              Cookies.set("without-subscription", true)
              publishUserCreated({status : status ? true : false})
              publishAppLoading(false)
              const routeState = getStorageItem("routeState");
                let nextRoute = await dynamicConfig(routeState,window.location.pathname,true)
                navigate(nextRoute)
            })
          }).catch((e) => {
            userDetails?.e ? (eventData.email = userDetails?.e, eventData.registeredVia = "email") : eventData.phoneNumber = (userDetails?.p, eventData.registeredVia = "phone number")
            let analyticsEventData={ename: ANALYTICSEVENTS.CHECKOUT_USER_CREATE_FAILURE, data: eventData};
            handleStatusGaCalls({eventName : 'checkout_user_login_failure',subSection : null, type : 'login', reason : 'true', status : null, action : 'Login Failure', paymentStatus : null,eventCategory : 'Checkout'})
            pubsub.publish('user-analytics',analyticsEventData)
            handleStatusGaCalls({eventName : 'signup_failure',subSection : 'login', type : 'failure', reason : e?.message, status : null, action : 'Failure', paymentStatus : null,eventCategory : 'Authentication'})
            publishErrorUpdate("Error while creating account")
            publishAppLoading(false)
          })
        })
        }
    }

    const showContinueWithoutSubscriptionCta = continueWithoutSubscription && !userExist
    let fontSetting = moduleData?.layout?.fontSetting
    const fontStyles = getFontsStyles(fontSetting)
    
    const getDataType = () => {
      let signIntext = metadataMap?.appleSignInButtonTitle?.toLowerCase()

      if(signIntext.includes("continue")) return 'continue'
      return "sign-in"
    }

  function getErrorMessages(message) {
    if (!message) return null;
    return message.replace(/^['"](.+)['"]$/, '$1');
  }

    const handleFreeLogin=async()=>{
       formType.category === "email" && logIn({email:verifiedValue,phone:formInputData?.phone !== "" ? ('+' + areacode + formInputData?.phone) : "",dob:formInputData?.dob,name:formInputData?.name,zipCode:formInputData?.zipCode}).then((res) => {
        pubsub.publish('verifyOtp',{type:{type:'email',value:verifiedValue,emailConsent:isEmailConsentEnable,key:res?.identityAuthOtpInitiate?.key},screen:true,value:verifiedValue})
        triggerUserBeaconEvents('CHECKOUT_USER_LOGIN_INIT', false)
        handleStatusGaCalls({eventName : 'checkout_user_login_init',subSection : null, type : 'login', reason : 'true', status : null, action : 'Login Initiated', paymentStatus : null,eventCategory : 'Checkout'})
      }).catch((error)=>{
        let errorData = getErrorMessages(error?.message)
        getErrorMessage(errorData)
      })

       formType.category === "mobile" && LogInMobile({
        phoneNumber:'+' + areacode + verifiedValue,email:formInputData.phone,
        dob:formInputData?.dob,name:formInputData?.name,zipCode:formInputData?.zipCode
      }).then((res) => {
        pubsub.publish('verifyOtp',{type:{type:'mobile',value: '+' + areacode + verifiedValue,key:res?.identityAuthOtpInitiate?.key},screen:true,value: '+' + areacode + verifiedValue})
        handleStatusGaCalls({eventName : 'checkout_user_login_init',subSection : null, type : 'login', reason : 'true', status : null, action : 'Login Initiated', paymentStatus : null,eventCategory : 'Checkout'})
        triggerUserBeaconEvents('CHECKOUT_USER_LOGIN_INIT', false)
      }).catch((error)=>{
        let errorData = getErrorMessages(error?.message)
        getErrorMessage(errorData)
      })
    }

    return (
      <div className="login-form">
        <div className="input-box">
          <form className="getVerified" onSubmit={(e) => setVerificationWindow(e)}>
            {!isCheckoutScreen && <div className="inputForm">
              {formType.category == "mobile" && !hideMobileNumber  ? (
                <PhoneInput
                  containerClass="reactInputTel"
                  country={window.app_data.countryCode?.toLowerCase()}
                  value={areacode}
                  onChange={handleOnChange}
                />
              ) : (
                false
              )}
              <input
                aria-labelledby={metadataMap?.emailTextFieldPlaceHolder || "Enter your email or phone number"}
                className={formType.category === "mobile" && !hideMobileNumber ? errMsg.type === "email" ? "getVerified-mobile errBorder" : "getVerified-mobile" : errMsg.type === "email" ? "getVerified-Email errBorder" : "getVerified-Email"}
                style={!isCheckoutScreen ? { background: inputColor, fontFamily: fontStyles?.loginV2InputBoxPlaceholder?.fontFamily, fontSize: fontStyles?.loginV2InputBoxPlaceholder?.fontSize } : {background: checkoutInputBgColor, color: checkoutInputColor}}
                value={verifiedValue}
                name="username"
                autocomplete="username"
                onKeyDown={handleValidateOnEvent}
                onBlur={(e) => isCheckoutScreen && verifiedValue.length > 0 && handleValidateOnBlur(e)}
                onChange={(e) => handleVerified(e)}
                placeholder={metadataMap?.emailTextFieldPlaceHolder || "Enter your email or phone number"}
                disabled={userExist}
                autoFocus
                data-test="email-field"
              />
              {successMsg && <div className="successMessage site-cta-color" data-test="email-vertfied">{greenTick()}</div>}
            </div>}
            {isCheckoutScreen && (
              <CheckoutFormInputs
                isCheckoutScreen={isCheckoutScreen}
                formType={formType}
                hideMobileNumber={hideMobileNumber}
                metadataMap={checkoutModuleData?.moduleData?.metadataMap}
                checkoutInputBgColor={checkoutInputBgColor}
                checkoutInputColor={checkoutInputColor}
                areacode={areacode}
                handleOnChange={handleOnChange}
                handleValidateOnEvent={handleValidateOnEvent}
                handleValidateOnBlur={handleValidateOnBlur}
                handleVerified={handleVerified}
                verifiedValue={verifiedValue}
                userExist={userExist}
                errMsg={errMsg}
                successMsg={successMsg}
                greenTick={greenTick}
                checkoutLayoutSettings={checkoutLayoutSettings}
                checkoutModuleData={checkoutModuleData}
                formInputData={formInputData}
                handleGameOnBlur={handleGameOnBlur}
                handleValueChange={handleValueChange}
              />
            )}
            {errMsg?.msg ? <div className="errMessage site-cta-color">
              {errorAlert()}
                <div>
                  {/* if navigatePermalink is active then it will replace the $delemeter text$ with span tag and text. */}
                  {String(errMsg.msg).split(/\$(.*?)\$/g).map((part, index) => {
                    if (navigatePermalink.isActive && part === navigatePermalink.localisation) {
                      return (
                        <span
                          key={index}
                          onClick={() =>
                            navigatePermalink.handleEventType === 'signUp'
                              ? navigate('/checkout')
                              : initiateOtp()
                          }
                          style={
                            navigatePermalink.handleEventType === 'signUp'
                              ? { color: 'white', textDecoration: 'underline' }
                              : { color: 'black', textDecoration: 'underline' }
                          }
                        >
                          {part}
                        </span>
                      );
                    }
                    return part;
                  })}
                </div>
              </div> : false}

            {isCheckoutScreen && !isUserLoggedIn && emailConsentOptions?.enableEmailConsent && <div className="custom-checkbox-wrapper">
              <div className="container" onClick={handleValidateOnTab}>
                <input aria-labelledby="Email consent checkbox" tabIndex={0} type="checkbox" onKeyDown={handleValidateOnTab} name="emailConsent"  checked={isEmailConsentEnable} disabled={userExist}/>
                <span className="checkmark"></span>
              </div>
              <div id='email-consent-checkbox-label' className="checkbox-label">{emailConsentOptions?.message || metadataMap?.emailConsentText || "Please send me email or other marketing communications regarding my account and other products from NewCo."}</div>
            </div>}

            {(!isDisabled && !isCheckoutScreen) && <button
              aria-label="get verification code"
              className={`getVerified-button site-cta-background-color site-cta-color ${isEmpty ? "disabled" : ""}`}
              style={isEmpty ? { background: disableCtaColor, fontFamily: fontStyles?.loginV2LoginCta?.fontFamily, fontSize: fontStyles?.loginV2LoginCta?.fontSize } : { background: activeCtaColor,color : `${activeCtaTextColor}`, fontFamily: fontStyles?.loginV2LoginCta?.fontFamily, fontSize: fontStyles?.loginV2LoginCta?.fontSize }}
              disabled={isEmpty}
              onClick={(e) => setVerificationWindow(e)}
              typeof="submit"
              data-test="login-submit-btn"
            >
              {metadataMap?.getVerificationCodeButtonTitle || "Get Verification Code"}
            </button>}

            {loading ? (
              <div className="loaderWrapper">
                <Spinner />
              </div>
            ) : (
              false
            )}
          </form>
        </div>
        {isFreeLogin && isCheckoutScreen && (<button type="button"  onClick={handleFreeLogin}  disabled={showBtn ? ((successMsg && verifiedValue !== "") ? false : true): true }  className={`continue-without-subscription-btn ${   showBtn ? (successMsg && verifiedValue!== "" ? "" : 'disabled-tve-btn'): 'disabled-tve-btn' }`}>{checkoutModuleData?.moduleData?.metadataMap?.freeSignupCtaText || "Sign Up for Free"}</button>)}
       {!isDisabled && (getEnableValue("Google") || getEnableValue("Apple")) ? <div className="divider">{metadataMap?.orTitle || 'or'}</div> : <></>}
        {!isDisabled && <div className="otherLogins">
          {getEnableValue("Google") ? <button aria-label="sign in with google" onClick={() => initGoogleSignIn()} className="googleBtn">
            <img alt="Google" src={google} />
            <span>{metadataMap?.googleSignInButtonTitle || "Sign in with Google"}</span>
          </button> : <></>}
          {getEnableValue("Apple") ? <div
            id="appleid-signin"
            data-color="white"
            className="signin-button"
            data-border="false"
            data-type={getDataType()}
            onClick={() => debounce(signInApple, 500)}
          />:<></> }
        </div>}
        <div className='login-bottom-info' style={{fontFamily: fontStyles?.loginV2Description?.fontFamily, fontSize: fontStyles?.loginV2Description?.fontSize}}>
          <p id="authSubtitle">{`${metadataMap?.tosTextDesc || 'By signing up, you are creating an account.'}`}
             <span style={{textDecoration: 'underline', cursor: 'pointer' ,color : siteCtaColor }} onClick={() => navigate(moduleData?.layout?.settings?.termsOfServicePagePath)}>{metadataMap?.tosText || 'Terms of Service'}</span>
          </p>
          {!isCheckoutScreen &&
            <p>
              {checkoutModuleData?.moduleData?.metadataMap?.freeSignupCtaText || "Don’t have an account?"}
              <span style={{textDecoration: 'underline', cursor: 'pointer', color: siteCtaColor, marginLeft: '5px'}} onClick={handleSignInEventRedirection}>
                { window?.app_data?.appcmsMain?.genericMessages?.errorDialogSignUpCta || 'Sign Up'}
              </span>
            </p>
          }
        </div>
        {isCheckoutScreen && showTvProviderBtn && !isFreeLogin  && <button aria-label="Continue to TVE Providers" className={!(isDisabled && showBtn) ? "connect-tve-btn disabled-tve-btn" : "connect-tve-btn site-cta-background-color site-cta-color"} id="initiateTveBtn" onClick={handleEnableTveFlow} disabled={!(isDisabled && showBtn)}>{metadataMap?.loginCtaTveProvideTitle || 'Continue to TV Providers'}</button>}
        {showContinueWithoutSubscriptionCta && !isFreeLogin && <button aria-label="Continue without subscription" type='button' disabled={showBtn ? ((successMsg && verifiedValue !== "") ? false : true) : true } className={"continue-without-subscription-btn"} onClick={onContinueWithoutSubscription}>{continueWithoutSubscriptionLabel ?? "Continue Without Subscription"}</button>}
        {loading && (
          <div className="loaderWrapper">
            <Spinner />
          </div>
        )}
      </div>
    );
}

export default Form